import { ReactElement } from 'react';

import { IframeProps } from './types';

export default function Iframe(props: IframeProps): ReactElement {
  const { title, src } = props;

  return (
    <iframe
      title={title}
      src={src}
      style={{
        width: '100%',
        height: '100%',

        border: 'transparent'
      }}
    />
  );
}
